import { TextField } from "@mui/material";
import styles from "../../../../propertydetails.module.css";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";
import NumberFormat from "react-number-format";
import * as yup from "yup";
import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { AddLogCallAPI } from "../../../../../../components/AddLogs";
import { toast } from "react-smart-toaster";

const schema = yup.object().shape({
    approval_deadline_days: yup.string().required("This field is Required").test("non-zero-validate", "This field should be 1 or greater.", (value) => parseInt(value) > 0)
});

const ProspectApprovalSettings = ({ approval_deadline_days, setLoading, setSnackbarMsg, setSnackbarOpen, setPropertyData, property_name, property_id }) => {
    const { getAccessTokenSilently, isAuthenticated, user } = useAuth0();
    const { handleSubmit, control, errors, setValue } = useForm({
        shouldUnregister: false,
        resolver: yupResolver(schema),
    });

    useEffect(() => {
        if (approval_deadline_days) {
            setValue('approval_deadline_days', approval_deadline_days);
        }
    }, [approval_deadline_days, setValue])

    const onSubmit = async (data) => {
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
        setLoading(true);
        return axios.put(process.env.REACT_APP_PROPERTY_API_URL + "v1/properties/" + property_id + "/update-prospect-approval", data, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then((response) => {
            setLoading(false);

            setSnackbarMsg(response.data.message);
            setSnackbarOpen(true);

            setPropertyData((prev) => {
                return { ...prev, min_credit_score: response.data?.data?.min_credit_score, min_income_multiplier: response.data?.data?.min_income_multiplier };
            });

            let logData = {
                title: "Prespect screening criteria is updated",
                description: ["Property: " + property_name],
            };
            AddLogCallAPI(logData, token);
        }).catch((error) => {
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    return (<form onSubmit={handleSubmit(onSubmit)}>
        <div style={{ maxWidth: "300px" }}>
            <div className={`${styles.FormRow}`}>
                <div className={`${styles.FormGroupFullPay} FormGroup`}>
                    <Controller
                        name={`approval_deadline_days`}
                        control={control}
                        render={(field) => (
                            <NumberFormat
                                value={field.value}
                                onChange={(e) => field.onChange(e)}
                                customInput={TextField}
                                prefix=""
                                displayType="input"
                                type="text"
                                thousandSeparator={false}
                                decimalScale={0}
                                label="Approval Deadline (Days)"
                                variant="outlined"
                            />)}
                    />
                    {errors.approval_deadline_days && (<p className={`${styles.ErrorM}`}>{errors?.approval_deadline_days?.message}</p>)}
                </div>
            </div>

            {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("property-settings:update") > -1 && <div>
                <button type="submit" className={`${styles.ButtonVoiletSolid}`}>Update</button>
            </div>}
        </div>
    </form>)
}

export default ProspectApprovalSettings;